import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'ACCESS_CONTROL_PAGE_TOGGLE_DIALOGUE',
  'ACCESS_CONTROL_PAGE_SET_POLICY_TO_EDIT',
  'ACCESS_CONTROL_PAGE_SET_EDIT_ACTIVE_STEP',
]);
